import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './routes';
import { AuthProvider } from './context/AuthContext';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter basename={process.env.REACT_APP_HOME_PAGE}>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
